import React, { useEffect,useState } from 'react';
import CircleSlider from '../../containers/Circle-Slider/Circle-Slider';
import NewLaunches from '../../containers/New-Launches/NewLaunches';
import CategoriesBox from '../../containers/Categories-Box/CategoriesBox';
import AccessoriesSection from '../../containers/Accessories-Section/AccessoriesSection';
import AboutUsSection from '../../containers/About-Us-Section/AboutUs';
import '../../assets/css/homepageproduct.css';
import { useDispatch, useSelector } from 'react-redux';
import '../../assets/css/slider.css';
import '../../assets/css/custom.css';
import { toast } from "react-toastify";
import { apiHandler } from '../../api';
import { endpoint } from '../../api/endpoint';
import {
  saveAccessories,
  saveNewlaunches,
  saveCatagory,
  saveBanner
} from '../../features/HomePageSlice/homeDataSlice';
import { ACCESSORIES, NEWLAUNCHES, HOMECATEGORY, BANNERS } from '../../assets/graphql';
import Customers from '../../hocs/Layout/Footer/Customers/Customers';
import ExcitingPage from '../Landing-Page/ExcitingPage';

const HomePage = () => { 
  const [loader, setLoader] = useState(false);
  const [loginURLCheck, setLoginURLCheck] = useState(false);
  const dispatch = useDispatch();
  const { storeconfig, landingData, landingCat } = useSelector((state) => state.home);
  const { token } = useSelector((state) => state.login);
  useEffect(() => {
    setLoginURLCheck(localStorage.getItem('loginURL'))
    if (storeconfig.accessories_category_id)
      getAccessoriesData(storeconfig.accessories_category_id);
    if (storeconfig.new_launch_sku)
      getNewLaunchesData(storeconfig.new_launch_sku.split(","));
  }, [storeconfig, landingData]);
  const getAccessoriesData = async (id) => {
    setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { id },
        query: ACCESSORIES,
      },
    });
    setLoader(false);
    if (!result.data.error_code) {
      const dataArray = landingData.categoriesProduct[0].selectedId.split(',');
      const filteredArray = result.data.products.items.filter((value) => dataArray.includes(value.categories[0].id.toString()));
      dispatch(saveAccessories(filteredArray));
    }
  };
  const getNewLaunchesData = async (newLaunchSku) => {
    
    setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { newLaunchSku },
        query: NEWLAUNCHES,
      },
    });
    setLoader(false);
    if (!result.data.error_code) {
      dispatch(saveNewlaunches(result.data.productDetail.items));
    }
  };
  const getHomeCategory = async (newLaunchSku) => {
    setLoader(true);
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: 'POST',
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: {},
        query: HOMECATEGORY,
      },
    });
    setLoader(false);
    if (!result.data.error_code) {
      dispatch(saveCatagory(result.data.category));
    }
  };

  const getBannersList = async (token) => {
    if (token) {
        const result = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            method: 'POST',
            authToken: token,
            data: {
                base_url: endpoint.API_BASE_URL,
                query: BANNERS,
                variables: {},
            },
        });
        // 
        if (!result.data.message) {
            dispatch(
                dispatch(saveBanner(result.data.sliderdata))
            );
        }
        else {
            toast.error(result.data.message);
           
        }
    }
  };

  useEffect(()=>{
    getBannersList(token);

  },[])

  return (
    <>
      <CircleSlider />
      {loginURLCheck === "default" ? <NewLaunches /> : "" }
      {loginURLCheck === "default" ? <CategoriesBox /> : <ExcitingPage catData={landingCat} /> }
      <AccessoriesSection />
      <AboutUsSection />
      {/* <Customers /> */}
      {/* {loader && (
        <div className='loading-overlay'>
          <div className='bounce-loader'> */}
            {/* <div className='bounce1'></div>
								<div className='bounce2'></div>
								<div className='bounce3'></div> */}
            {/* <div className="loader"></div>
          </div>
        </div> */}
      {/* )} */}
    </>
  );
};

export default HomePage;
